webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.router = exports.App = undefined;
	
	var _vue = __webpack_require__(23);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(127);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _router = __webpack_require__(49);
	
	var _router2 = _interopRequireDefault(_router);
	
	__webpack_require__(103);
	
	__webpack_require__(106);
	
	__webpack_require__(105);
	
	__webpack_require__(104);
	
	__webpack_require__(101);
	
	__webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_router2.default.start(_App2.default, '#app');
	
	exports.App = _App2.default;
	exports.router = _router2.default;

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  api_endpoint: 'https://tempd.link',
	  file_endpoint: 'https://tempd.link'
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(23);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(135);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _MainView = __webpack_require__(131);
	
	var _MainView2 = _interopRequireDefault(_MainView);
	
	var _AboutView = __webpack_require__(130);
	
	var _AboutView2 = _interopRequireDefault(_AboutView);
	
	var _TosView = __webpack_require__(134);
	
	var _TosView2 = _interopRequireDefault(_TosView);
	
	var _PrivacyView = __webpack_require__(133);
	
	var _PrivacyView2 = _interopRequireDefault(_PrivacyView);
	
	var _NotFoundView = __webpack_require__(132);
	
	var _NotFoundView2 = _interopRequireDefault(_NotFoundView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  history: true
	});
	
	router.map({
	  '/': {
	    name: 'main',
	    component: _MainView2.default
	  },
	  '/about': {
	    name: 'about',
	    component: _AboutView2.default
	  },
	  '/tos': {
	    name: 'tos',
	    component: _TosView2.default
	  },
	  '/privacy': {
	    name: 'privacy',
	    component: _PrivacyView2.default
	  },
	  '/404': {
	    name: 'not-found',
	    component: _NotFoundView2.default
	  }
	});
	
	router.beforeEach(function () {
	  window.scrollTo(0, 0);
	});
	
	router.redirect({
	  '*': '/'
	});
	
	exports.default = router;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Navigation = __webpack_require__(129);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Header = __webpack_require__(128);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _app = __webpack_require__(48);
	
	var _app2 = _interopRequireDefault(_app);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      show_header: true,
	      config: _app2.default
	    };
	  },
	
	  components: {
	    'navigation-componenet': _Navigation2.default,
	    'header-componenet': _Header2.default
	  }
	};

/***/ },
/* 51 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  props: ['showHeader']
	
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(53);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _vue = __webpack_require__(23);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _dropzone = __webpack_require__(87);
	
	var _dropzone2 = _interopRequireDefault(_dropzone);
	
	var _socket = __webpack_require__(112);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_dropzone2.default.autoDiscover = false;
	
	var DZ = void 0;
	var socket = void 0;
	var init_token = '';
	
	exports.default = {
	
	  props: ['showHeader'],
	
	  data: function data() {
	    return {
	      counter: 0,
	      files_index: {},
	      files: []
	    };
	  },
	
	
	  methods: {
	    deleteUpload: function deleteUpload(file) {
	      if (socket && file && file.upload_token) {
	        file.expired = true;
	        socket.emit('upload_delete', {
	          'upload_token': file.upload_token
	        });
	      }
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    socket = (0, _socket2.default)(this.$root.config.api_endpoint);
	
	    socket.on('token', function (data) {
	
	      data = data || {};
	
	      if (data.type === 'new') {
	
	        if (DZ) {
	          DZ.options.headers['TEMPd-Token'] = data.tempd_token;
	        } else {
	          init_token = data.tempd_token;
	        }
	      } else if (data.type === 'refresh') {
	
	        socket.emit('token_refresh', {
	          'token': data.token
	        });
	      }
	    });
	
	    socket.on('upload', function (data) {
	      if (data.type === 'expire') {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(_this.files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var file = _step.value;
	
	            if (file.upload_token === data.upload_token) {
	              file.expired = true;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      } else if (data.type === 'accessed') {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(_this.files), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var _file = _step2.value;
	
	            if (_file.upload_token === data.upload_token) {
	              _file.accessed += 1;
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	    });
	  },
	  ready: function ready() {
	    var _this2 = this;
	
	    DZ = new _dropzone2.default(document.body, {
	      url: this.$root.config.api_endpoint + '/api/upload',
	      maxFilesize: 10,
	      clickable: '#upload',
	      headers: {
	        'TEMPd-Token': init_token
	      },
	      addedfile: function addedfile(file) {
	
	        if (_this2.$root.show_header) {
	          _this2.$root.show_header = false;
	        }
	
	        file.file_id = ++_this2.counter;
	
	        _vue2.default.set(_this2.files_index, file.file_id, {
	          progress: 0
	        });
	
	        _this2.files.unshift({
	          file: file,
	          file_id: file.file_id,
	          name: file.name,
	          upload_token: '',
	          extension: '',
	          accessed: 0,
	          progress: 0,
	          success: false,
	          error: false,
	          expired: false
	        });
	      },
	      uploadprogress: function uploadprogress(file, progress, bytes) {
	        _this2.files_index[file.file_id].progress = progress;
	      },
	      success: function success(file, response) {
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	
	          for (var _iterator3 = (0, _getIterator3.default)(_this2.files), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var init_file = _step3.value;
	
	            if (init_file.file === file) {
	              init_file.upload_token = response.upload_token;
	              init_file.extension = response.extension;
	              init_file.success = true;
	            }
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	      },
	      error: function error(file, response, xhr) {
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	
	          for (var _iterator4 = (0, _getIterator3.default)(_this2.files), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var init_file = _step4.value;
	
	            if (init_file.file === file) {
	              if (xhr) {
	                init_file.error = response.error;
	              } else {
	                init_file.error = response;
	              }
	              init_file.expired = true;
	            }
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	      }
	    });
	  }
	};

/***/ },
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 98 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 99 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 100 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 101 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 102 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 103 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 104 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 105 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 106 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 118 */,
/* 119 */
/***/ function(module, exports) {

	module.exports = " <section class=container> <h2>About</h2> <p>TEMPd aims to provide a simple file hosting service for quick sharing of files with immediate deletion based on a short and strict expiry time or when a user leaves the site.</p> <ul> <li>All uploaded files are stored in memory until they are automatically expired or deleted. Due to resource limitations, there is a 10MB limit per file.</li> <li>There is an initial expiry time of 30 seconds for each upload and this is extended for a further 30 seconds after the first time the file is accessed. The longest possible time a file can be available for download is 60 seconds, after which the file will be automatically deleted.</li> <li>If the user uploading the files leave the site (page close, refresh, disconnect etc.) then all files will be deleted immediately, regardless of the time left till expiry.</li> <li>No data is logged by TEMPd on uploads. Currently, Google Analytics is the only service used to measure site traffic.</li> <li>The status indicators are as follows: <ul> <li><i class=\"icon-spin1 animate-spin\" aria-hidden=true></i> - Upload in progress (a progress bar is also displayed below)</li> <li><i class=\"icon-circle-empty green\" aria-hidden=true></i> - Upload successful and a link is available for sharing</li> <li><i class=\"icon-ok-circled2 green\" aria-hidden=true></i> - The link has been accessed at least once (a counter is displayed in the view button below)</li> <li><i class=\"icon-cancel-circled2 red\" aria-hidden=true></i> - Upload expired, manually deleted (using the delete button below) or if there is an error uploading</li> </ul> </li> </ul> <p>Please create an issue <a href=https://github.com/cxam/tempd.link/issues target=_blank>here</a> if you find bugs or have any feedback, thanks.</p> </section> ";

/***/ },
/* 120 */
/***/ function(module, exports) {

	module.exports = " <header class=header id=not-found> <section class=container> <div transition=fade> <img class=img src=/static/img/tempd.png alt=TEMPd title=TEMPd> <h1 class=title>TEMPd</h1> <p class=description> Looks like the file you were looking for is already gone! </p> </div> </section> </header> ";

/***/ },
/* 121 */
/***/ function(module, exports) {

	module.exports = " <section class=container> <h2>Privacy Policy</h2> <p>Your privacy is important to us.</p> <p>It is TEMPd's policy to respect your privacy regarding any information we may collect while operating our website. Accordingly, we have developed this privacy policy in order for you to understand how we collect, use, communicate, disclose and otherwise make use of personal information. We have outlined our privacy policy below.</p> <ul> <li>We will collect personal information by lawful and fair means and, where appropriate, with the knowledge or consent of the individual concerned.</li> <li>Before or at the time of collecting personal information, we will identify the purposes for which information is being collected.</li> <li>We will collect and use personal information solely for fulfilling those purposes specified by us and for other ancillary purposes, unless we obtain the consent of the individual concerned or as required by law.</li> <li>Personal data should be relevant to the purposes for which it is to be used, and, to the extent necessary for those purposes, should be accurate, complete, and up-to-date.</li> <li>We will protect personal information by using reasonable security safeguards against loss or theft, as well as unauthorized access, disclosure, copying, use or modification.</li> <li>We will make readily available to customers information about our policies and practices relating to the management of personal information.</li> <li>We will only retain personal information for as long as necessary for the fulfilment of those purposes.</li> </ul> <p>We are committed to conducting our business in accordance with these principles in order to ensure that the confidentiality of personal information is protected and maintained. TEMPd may change this privacy policy from time to time at TEMPd's sole discretion.</p> </section> ";

/***/ },
/* 122 */
/***/ function(module, exports) {

	module.exports = " <section class=container> <h2>Terms of Service</h2> <h3>1. Terms</h3> <p>By accessing the website at <a href=https://tempd.link>https://tempd.link</a>, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law.</p> <h3>2. Use License</h3> <ol type=a> <li> Permission is granted temporarily to each user of TEMPd's services for worldwide, non-exclusive, non-sublicensable and non-transferable license, for personal and commercial use. This is the grant of a license, not a transfer of title, and under this license you may not: <ol type=i> <li>modify or copy the materials;</li> <li>attempt to decompile or reverse engineer any software contained on TEMPd's website;</li> <li>remove any copyright or other proprietary notations from the materials; or</li> <li>transfer the materials to another person or \"mirror\" the materials on any other server.</li> </ol> </li> <li>This license shall automatically terminate if you violate any of these restrictions and may be terminated by TEMPd at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.</li> </ol> <h3>3. Disclaimer</h3> <ol type=a> <li>The materials on TEMPd's website are provided on an 'as is' basis. TEMPd makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</li> <li>Further, TEMPd does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.</li> </ol> <h3>4. Limitations</h3> <p>In no event shall TEMPd or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on TEMPd's website, even if TEMPd or a TEMPd authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.</p> <h3>5. Accuracy of materials</h3> <p>The materials appearing on TEMPd's website could include technical, typographical, or photographic errors. TEMPd does not warrant that any of the materials on its website are accurate, complete or current. TEMPd may make changes to the materials contained on its website at any time without notice. However TEMPd does not make any commitment to update the materials.</p> <h3>6. Links</h3> <p>TEMPd has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by TEMPd of the site. Use of any such linked website is at the user's own risk.</p> <h3>7. Modifications</h3> <p>TEMPd may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.</p> <h3>8. Governing Law</h3> <p>These terms and conditions are governed by and construed in accordance with the laws of TEMPd and you irrevocably submit to the exclusive jurisdiction of the courts in United Kingdom.</p> </section> ";

/***/ },
/* 123 */
/***/ function(module, exports) {

	module.exports = " <main class=wrapper _v-05b904ad=\"\"> <navigation-componenet _v-05b904ad=\"\"></navigation-componenet> <header-componenet :show-header=show_header v-show=\"['main'].indexOf($route.name) > -1\" _v-05b904ad=\"\"> </header-componenet> <router-view class=view keep-alive=\"\" transition=\"\" transition-mode=out-in _v-05b904ad=\"\"> </router-view> </main> ";

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <nav class=navigation _v-69b5ca79=\"\"> <section class=container _v-69b5ca79=\"\"> <a class=navigation-title v-link=\"{path: '/'}\" _v-69b5ca79=\"\"> <img class=img src=" + __webpack_require__(117) + " height=30 alt=Milligram title=Milligram _v-69b5ca79=\"\"> <h1 class=title _v-69b5ca79=\"\">TEMPd</h1> </a> <ul class=\"navigation-list float-right\" _v-69b5ca79=\"\"> <li class=navigation-item _v-69b5ca79=\"\"> <a class=navigation-link v-link=\"{path: '/about', activeClass: 'active'}\" _v-69b5ca79=\"\"> <b _v-69b5ca79=\"\">About</b> </a> </li> <li class=navigation-item _v-69b5ca79=\"\"> <a class=navigation-link v-link=\"{path: '/tos', activeClass: 'active'}\" _v-69b5ca79=\"\"> <b _v-69b5ca79=\"\">ToS</b> </a> </li> <li class=navigation-item _v-69b5ca79=\"\"> <a class=navigation-link v-link=\"{path: '/privacy', activeClass: 'active'}\" _v-69b5ca79=\"\"> <b _v-69b5ca79=\"\">Privacy</b> </a> </li> </ul> </section> </nav> ";

/***/ },
/* 125 */
/***/ function(module, exports) {

	module.exports = " <section v-show=!$root.show_header class=\"container mid-container\" _v-6d6136ba=\"\"> <table _v-6d6136ba=\"\"> <thead _v-6d6136ba=\"\"> <tr _v-6d6136ba=\"\"> <th _v-6d6136ba=\"\"></th> </tr> </thead> <tbody _v-6d6136ba=\"\"> <tr v-for=\"file in files\" :class=\"{'expired': file.expired}\" _v-6d6136ba=\"\"> <td _v-6d6136ba=\"\"> <dl _v-6d6136ba=\"\"> <dt _v-6d6136ba=\"\"> <i v-show=\"!file.success &amp;&amp; !file.error &amp;&amp; !file.expired\" class=\"icon-spin1 animate-spin\" aria-hidden=true _v-6d6136ba=\"\"></i> <i v-show=\"file.success &amp;&amp; !file.accessed &amp;&amp; !file.expired\" class=\"icon-circle-empty green\" aria-hidden=true _v-6d6136ba=\"\"></i> <i v-show=\"file.success &amp;&amp; file.accessed &amp;&amp; !file.expired\" class=\"icon-ok-circled2 green\" aria-hidden=true _v-6d6136ba=\"\"></i> <i v-show=\"file.error || file.expired\" class=\"icon-cancel-circled2 red\" aria-hidden=true _v-6d6136ba=\"\"></i> <span class=\"file-name break-line\" _v-6d6136ba=\"\">{{file.name}}</span> </dt> <dt class=file-link-section _v-6d6136ba=\"\"> <small _v-6d6136ba=\"\" _v-6d6136ba=\"\"> <a class=file-link v-show=file.upload_token :href=\"$root.config.file_endpoint + '/f/' + file.upload_token + '.' + file.extension\" target=_blank _v-6d6136ba=\"\"> {{$root.config.file_endpoint}}/f/{{file.upload_token}}.{{file.extension}} </a> </small><div class=progress-outer v-show=\"!file.upload_token &amp;&amp; !file.error\" _v-6d6136ba=\"\"><small _v-6d6136ba=\"\" _v-6d6136ba=\"\"> <div class=progress-inner :style=\"{width: files_index[file.file_id].progress + '%'}\" _v-6d6136ba=\"\"> </div> <span class=break-line v-show=file.error _v-6d6136ba=\"\">{{file.error | capitalize}}</span> </small> </div></dt> <dt _v-6d6136ba=\"\"> <div v-show=\"file.success &amp;&amp; !file.expired\" class=\"file-controls float-right\" _v-6d6136ba=\"\"> <a :href=\"$root.config.file_endpoint + '/f/' + file.upload_token + '.' + file.extension\" target=_blank class=\"button button-small button-outline grey-border blue\" _v-6d6136ba=\"\"> View ({{file.accessed}}) </a> <button class=\"button button-small button-outline grey-border red\" @click=deleteUpload(file) _v-6d6136ba=\"\"> Delete </button> </div> </dt> </dl> </td> </tr> </tbody> </table> </section> ";

/***/ },
/* 126 */
/***/ function(module, exports) {

	module.exports = " <header class=header id=home _v-92b0a61c=\"\"> <section class=container _v-92b0a61c=\"\"> <div v-show=showHeader transition=fade _v-92b0a61c=\"\"> <img class=img src=/static/img/tempd.png alt=TEMPd title=TEMPd _v-92b0a61c=\"\"> <h1 class=title _v-92b0a61c=\"\">TEMPd</h1> <p class=description _v-92b0a61c=\"\"> Temporary file hosting with immediate automatic deletion when leaving the site. </p> </div> <button id=upload class=\"button no-margin-bottom\" _v-92b0a61c=\"\">Drop files or tap to upload</button> </section> </header> ";

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(97)
	__vue_script__ = __webpack_require__(50)
	__vue_template__ = __webpack_require__(123)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(100)
	__vue_script__ = __webpack_require__(51)
	__vue_template__ = __webpack_require__(126)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(98)
	__vue_template__ = __webpack_require__(124)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_template__ = __webpack_require__(119)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(99)
	__vue_script__ = __webpack_require__(52)
	__vue_template__ = __webpack_require__(125)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_template__ = __webpack_require__(120)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_template__ = __webpack_require__(121)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_template__ = __webpack_require__(122)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 135 */,
/* 136 */,
/* 137 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.13b40f929d707fb61388.js
 **/